import { formatMoney } from '../../utils/money';

/**
 * Importe con signo explícito ("+ $ 1.000,00" / "− $ 1.000,00"): el sentido del movimiento se lee en el texto,
 * no solo en el color (design system).
 */
export function formatSignedMoney(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '—';
    if (amount === 0) return formatMoney(0);
    return `${amount > 0 ? '+' : '−'} ${formatMoney(Math.abs(amount))}`;
}

/** Saldo: el negativo con "−" adelante del símbolo ("− $ 1.000,00"), el positivo sin signo. */
export function formatBalance(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '—';
    return amount < 0 ? `− ${formatMoney(Math.abs(amount))}` : formatMoney(amount);
}
